<template>
  <div>
    <div class="plate-title">
      <span style="font-weight: bold;color: #333;display: inline-block;padding-bottom: 10px;">Coupons Logs</span>
      <s-table
        ref="table"
        size="small"
        rowKey="id"
        showQuickJumper
        :columns="columns"
        :data="loadData"
      >
        <template slot="operationType" slot-scope="text,record">
          <span v-if="record.operationType ==='A'">Add</span>
          <span v-else-if="record.operationType ==='B'">Use</span>
          <span v-else-if="record.operationType ==='C'">Recover</span>
        </template>
        <template slot="changeFrom" slot-scope="text,record">
          <span v-if="record.changeFrom ==='A'">CDB</span>
          <span v-else>OBS</span>
        </template>
      </s-table>
    </div>
  </div>
</template>

<script>
import STable from '@/components/table/'
import { toSTablePage } from '@/utils/util'
import CouponApi from '@/api/api-cdb-membership-coupon'

export default {
  name: 'MembershipCouponLogs',
  components: {
    STable
  },
   props: {
    membershipId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: 'Date/Time',
          dataIndex: 'changeTime',
          width: '160px',
          customRender: (value, record) => this.DateTimeUtil().localString(value !== null ? value : record.changeTime, 'MM/DD/YYYY hh:mm:ss')
        },
        {
          title: 'Type',
          dataIndex: 'operationType',
          width: '70px',
          scopedSlots: { customRender: 'operationType' }
        },
        {
          title: 'From',
          dataIndex: 'changeFrom',
          width: '70px',
          scopedSlots: { customRender: 'changeFrom' }
        },
        {
          title: 'Booking No.',
          dataIndex: 'bookingNumber',
          width: '100px',
          customRender: (value) => value ? value : ''
        },
        {
          title: 'CDB By',
          dataIndex: 'operationBy',
          width: '160px',
          customRender: (value) => value ? value.userName : ''
        },
        {
          title: 'OBS By',
          dataIndex: 'obsOperatorName',
          customRender: (value) => value ? value : ''
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        return CouponApi.queryLog(this.membershipId, Object.assign(parameter, this.queryParam))
          .then(res => {
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  mounted () {
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    resetSearchForm () {
      this.queryParam = {}
    },
    refreshLogs () {
      this.$refs.table.refresh(true)
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .ant-advanced-search-form {
  padding-top: 0;
}
.plate-title:before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 15px;
  margin-right: 6px;
  background: #1890ff;
  position: relative;
  top: 3px;
}
</style>
